// extracted by mini-css-extract-plugin
export default {"up":"up_up__IPeS8","upAr":"up_upAr__Ww4KM","Shimiring":"up_Shimiring__mX1jD"};